// Dependencies
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Material UI Components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

// Components
import ListingCard from "components/cards/ListingCard/ListingCard.component";
import VehicleCardSkeleton from "components/cards/VehicleCard/VehicleCard.skeleton";

// Helpers
import { vdpRoute } from "routes";
import { fetchRecommendedListings } from "reducers/evergreen-reducer";
import useGeolocation from "context/useGeolocation.context";
import usePageWidth from "hooks/usePageWidth.hook";

// Styles
import { useStyles } from "./RecentlyViewed.styles";

const RecentlyViewed = () => {
  const classes = useStyles();
  const { isMobileWidth } = usePageWidth();
  const dispatch = useDispatch();
  const [location] = useGeolocation();
  const recommendedListings = useSelector(
    (state) => state.evergreen.recommendedListings,
  ).slice(0, !isMobileWidth ? 8 : 3);

  // Placeholder data - replace with query results
  const isLoading = recommendedListings.length === 0;

  const loaders = () => [
    <VehicleCardSkeleton key="vehicle-placeholder-1" />,
    <VehicleCardSkeleton key="vehicle-placeholder-2" />,
    <VehicleCardSkeleton key="vehicle-placeholder-3" />,
    <VehicleCardSkeleton key="vehicle-placeholder-4" />,
  ];

  const displayRecentlyViewed = () => {
    const returnItem = [];
    if (isLoading) {
      returnItem.push(loaders());
    } else {
      returnItem.push(
        recommendedListings.map((listing) => (
          <ListingCard
            key={listing.id}
            listing={listing}
            dataCy="recently-viewed-listing-card"
            href={{
              pathname: vdpRoute,
              query: {
                year: listing.vehicle.year,
                make: listing.vehicle.model.make.name,
                model: listing.vehicle.model.name,
                city: listing.address.city,
                vehicleId: listing.vehicle.id,
              },
            }}
          />
        )),
      );
    }

    return returnItem;
  };

  useEffect(() => {
    dispatch(fetchRecommendedListings({ location }, true));
  }, [location]);

  return (
    <Container
      className={classes.recentlyViewedContainer}
      maxWidth="lg"
      data-component="RecentlyViewed"
    >
      <Typography
        variant="h2"
        className={classes.recentlyViewedTitle}
        data-cy="vehicle-name"
      >
        People also viewed
      </Typography>
      <Grid container spacing={2}>
        {displayRecentlyViewed()[0].map((listing) => (
          <Grid key={listing?.id} item xs={12} sm={6} md={3}>
            {listing}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default RecentlyViewed;
